import { styled } from '@mui/material/styles'
import { Card } from '@mui/material'
import { boxShadow } from '@/constant'

export const PlainCard = styled(Card)(() => ({
  flex: 1,
  marginBottom: '24px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow,
  backgroundImage: 'none',
}))

export const Row = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
}))
